import Hero from './Hero';
import SearchSection from './SearchSection';
import Slider from './Slider';
import SpecialitiesOverview from './SpecialitiesOverview';
import StructuredData from './StructuredData';

export { Hero, SearchSection, Slider, SpecialitiesOverview, StructuredData };
